import { selectAllTerminalType, insertTerminalType, deleteTerminalType, selectAliKey, insertAliKey, deleteAliKey } from "../../api/config/modules/TerminalCommand";

const state = { selectAllTerminalType: {}, insertTerminalType: {}, deleteTerminalType: {}, selectAliKey: {}, insertAliKey: {}, deleteAliKey: {}};

const mutations = {
    SET_TERMINALTYPE: (state, selectAllTerminalType) => { state.selectAllTerminalType = selectAllTerminalType },
    SET_INAERTTYPE: (state, insertTerminalType) => { state.insertTerminalType = insertTerminalType },
    SET_DELETETYPE: (state, deleteTerminalType) => { state.deleteTerminalType = deleteTerminalType },
    SET_SELECTALIKEY: (state, selectAliKey) => { state.selectAliKey = selectAliKey },
    SET_INSERTALIKEY: (state, insertAliKey) => { state.insertAliKey = insertAliKey },
    SET_DELETEALIKEY: (state, deleteAliKey) => { state.deleteAliKey = deleteAliKey },
};

const actions = {
    GET_TERMINALTYPE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            selectAllTerminalType(data)
                .then((res) => {
                    commit("SET_TERMINALTYPE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_INAERTTYPE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            insertTerminalType(data)
                .then((res) => {
                    commit("SET_INAERTTYPE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_DELETETYPE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            deleteTerminalType(data)
                .then((res) => {
                    commit("SET_DELETETYPE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_SELECTALIKEY: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            selectAliKey(data)
                .then((res) => {
                    commit("SET_SELECTALIKEY", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_INSERTALIKEY: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            insertAliKey(data)
                .then((res) => {
                    commit("SET_INSERTALIKEY", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_DELETEALIKEY: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            deleteAliKey(data)
                .then((res) => {
                    commit("SET_DELETEALIKEY", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
